import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { addProduct } from "../../api/product.api";
import { productKeys } from "../../queryKeys";

export const useAddProduct = () => {

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addProduct,

    onSuccess: (res) => {
      if (res.message?.toLowerCase() === "success") {
        toast.success("Product Added!");

        // refresh product list
        queryClient.invalidateQueries({
          queryKey: productKeys.all,
        });
      }
    },

    onError: (error) => {
      toast.error("Failed to Add new Product!");
      console.error(error);
    },
  });
};
